import React from 'react';
const MODULES = [{
  title: 'TOMO 1 – Entendiendo el sueño de tu bebé'
}, {
  title: 'TOMO 2 – Señales de sueño'
}, {
  title: 'TOMO 3 – Método Sueño Seguro y Responsivo'
}, {
  title: 'TOMO 4 – Rutinas y entorno ideal'
}, {
  title: 'TOMO 5 – Técnicas naturales para dormir'
}, {
  title: 'TOMO 6 – Plan completo de 7 días'
}];
export function Modules() {
  return <section className="py-10 px-4 bg-white" data-id="element-69">
      <div className="max-w-5xl mx-auto" data-id="element-70">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-blue-900 mb-8" data-id="element-71">
          📘 ¿QUÉ INCLUYE EXACTAMENTE?
        </h2>

        <div className="grid md:grid-cols-2 gap-4" data-id="element-72">
          {MODULES.map((mod, i) => <div key={i} className="flex items-center gap-4 p-4 bg-gray-50 rounded-xl border border-gray-100" data-id="element-73">
              <div className="flex-shrink-0" data-id="element-74">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 text-lg" data-id="element-75">
                  📖
                </div>
              </div>
              <h3 className="font-bold text-base text-gray-900" data-id="element-76">{mod.title}</h3>
            </div>)}
        </div>

        <div className="text-center mt-8" data-id="element-77">
          <p className="text-xl font-bold text-gray-800 bg-yellow-100 inline-block px-6 py-3 rounded-lg" data-id="element-78">
            Todo organizado paso a paso
          </p>
        </div>
      </div>
    </section>;
}